import { WorkspaceSections } from '@/sections/Sidebar/types';

interface MatchParams {
  section?: WorkspaceSections;
  teamId?: string;
}

enum Filter {
  All = 'all',
  RUNNING = 'running',
  SCALED_TO_ZERO = 'scaled_to_zero',
  INACTIVE = 'inactive',
  FAILED = 'failed',
}

enum SortBy {
  PRODUCTION = 'production',
  RECENTLY_ACTIVE = 'recently_active',
  CREATED = 'created',
}

enum SortByTraining {
  RECENTLY_ACTIVE = 'recently_active',
  CREATED = 'created',
}

export { WorkspaceSections, MatchParams, Filter, SortBy, SortByTraining };
